export default __webpack_public_path__ + "static/media/audio.3d402714.gif";